import {gsap, ScrollTrigger} from "../Utility/gsap";

class AnimatedSprite {
  
  constructor( el ) {
    this.el = el;
    
    this.generateOptionsFromAttributes();

    switch( this.animationType ) {

      case 'loop':
        this.play();
        break;
      case 'once':
        this.playOnce();
        break;
      case 'hover':
        this.setupHover();
        break;
    }
    
  }

  setupHover() {

    if(this.el) {

      const onHover = (e) => {
        this.play();
      }

      const onUnhover = (e) => {
        this.stop();
        this.goToFrame(0);
      }

      this.el.parentElement.removeEventListener('mouseenter', onHover );
      this.el.parentElement.addEventListener('mouseenter', onHover );
      this.el.parentElement.removeEventListener('mouseleave', onUnhover );
      this.el.parentElement.addEventListener('mouseleave', onUnhover );
    }
  }

  playOnce() {

    const transition = gsap.to( this.el, {
      duration: (this.totalFrames * this.speed) / 1000,
      onStart: () => {
          this.play();
      },
      onComplete: () => {
          this.stop();
      }
    });

    ScrollTrigger.create({
        trigger: this.el,
        animation: transition,
        start: `bottom bottom`,
    });
  }

  generateOptionsFromAttributes() {

    this.currentFrame = 0;
    this.speed = parseInt(this.el.dataset?.animationSpeed) ?? 100;
    this.totalFrames = parseInt(this.el.dataset?.totalFrames) ?? 1;
    this.animationType = this.el.dataset?.animationType ?? 'loop';
    this.el.style.setProperty( '--frame-height', this.el.querySelector('img').naturalHeight + 'px' );

  }
  
  goToFrame(frame) {
    if(frame >= 0 && frame <= this.totalFrames ) {
      this.currentFrame = frame;
      this.el.style.setProperty( '--current-frame', this.currentFrame );
    }
  }
  
  nextFrame() {
    this.currentFrame = (this.currentFrame + 1) % this.totalFrames;
    this.el.style.setProperty( '--current-frame', this.currentFrame );
  }
  
  render() {
    this.nextFrame();
    
    if( this.isPlaying ) {
      setTimeout( this.render.bind(this), this.speed );
    }
  }
  
  play() {
    this.isPlaying = true;
    this.render();
  }
  
  pause() {
    this.isPlaying = false;
  }

  stop() {
    this.pause();
    this.goToFrame(0);
  }
}

const InitializeAnimatedIllustrations = () => {

  const illustrations = document.querySelectorAll('.illustration.sprite');

  illustrations.forEach( ill => {
    if(!ill.animation ) {
      ill.animation = new AnimatedSprite( ill );
    }
  });
}

export { AnimatedSprite, InitializeAnimatedIllustrations };